import {
  BW_LIGHTS,
  NEUTRAL_FILTER,
  SEPIA_FILTER,
  WARM_LIGHTS,
  WORKSHOP_FILTER,
  COOL_LIGHTS,
  GOLDEN_LIGHTS,
  CAT_FILTER,
  WARM_BOOK,
  BEAST_FILTER,
  BIRD_FILTER,
  COOL_BOOK,
  PURPLE_BOOK,
  GREEN_BOOK,
  WARM_CURIOSO,
  PURPLE_CURIOSO,
  COOL_CURIOSO,
  GREEN_CURIOSO,
} from 'root/lib/filters/matrices';

const extendMatrix = matrix => [
  ...matrix.map(row => [...row, 0, 0]),
  [0, 0, 0, 1, 0],
];

const matrixToString = matrix => matrix.map(row => row.join(' ')).join('\n');

export const sepiaFilter = matrixToString(extendMatrix(SEPIA_FILTER));

export const neutralFilter = matrixToString(extendMatrix(NEUTRAL_FILTER));

export const warmFilter = matrixToString(extendMatrix(WARM_LIGHTS));

export const bwFilter = matrixToString(extendMatrix(BW_LIGHTS));

export const warmCuriosoFilter = matrixToString(extendMatrix(WARM_CURIOSO));

export const purpleCuriosoFilter = matrixToString(extendMatrix(PURPLE_CURIOSO));

export const coolCuriosoFilter = matrixToString(extendMatrix(COOL_CURIOSO));

export const greenCuriosoFilter = matrixToString(extendMatrix(GREEN_CURIOSO));

export const orangeFilter = matrixToString(extendMatrix(CAT_FILTER));

export const greenFilter = matrixToString(extendMatrix(BIRD_FILTER));

export const purpleFilter = matrixToString(extendMatrix(BEAST_FILTER));

export const workshopFilter = matrixToString(extendMatrix(WORKSHOP_FILTER));

export const coolFilter = matrixToString(extendMatrix(COOL_LIGHTS));

export const goldenFilter = matrixToString(extendMatrix(GOLDEN_LIGHTS));

export const catlizardFilter = matrixToString(extendMatrix(CAT_FILTER));

export const birdFilter = matrixToString(extendMatrix(BIRD_FILTER));

export const beastFilter = matrixToString(extendMatrix(BEAST_FILTER));

export const warmBookFilter = matrixToString(extendMatrix(WARM_BOOK));

export const coolBookFilter = matrixToString(extendMatrix(COOL_BOOK));

export const purpleBookFilter = matrixToString(extendMatrix(PURPLE_BOOK));

export const greenBookFilter = matrixToString(extendMatrix(GREEN_BOOK));
